<template>

<div class="use-card table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">卡月用量统计</span>
        <el-form inline class="hook right themed-form search-form" style="height: 40px;line-height: 40px;">
            <el-form-item label="运营商:">
                <el-select v-model="form.accountId" filterable>
                    <el-option v-for="(item,index) in accountList" :label="item.accountName" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="代理商:">
                <el-select v-model="form.agentId" filterable>
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="(item,index) in agentList" :label="item.agentThreeName" :value="item.agentThreeId" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ICCID:">
                <el-input v-model="form.iccidMark" class="iccid-width"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchTable">搜索查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-download" class="themed-button" @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="运营商" prop="accountName" show-overflow-tooltip></el-table-column>
            <el-table-column label="ICCID" prop="iccidMark" width="180"></el-table-column>
            <el-table-column label="接入号" prop="phone" show-overflow-tooltip></el-table-column>
            <el-table-column label="代理商" prop="agentThreeName" show-overflow-tooltip></el-table-column>
            <el-table-column label="销售" prop="saleName" show-overflow-tooltip></el-table-column>
            <el-table-column label="流量" prop="usedFlow" show-overflow-tooltip>
                <template  slot-scope="scope">
                    <span v-if="scope.row.usedFlow">{{scope.row.usedFlow}} MB</span>
                    <span v-else>0</span>
                </template>
            </el-table-column>
            <el-table-column label="语音" prop="usedVoice" show-overflow-tooltip>
                <template  slot-scope="scope">
                    <span v-if="scope.row.usedVoice">{{scope.row.usedVoice}} 分钟</span>
                    <span v-else>0</span>
                </template>
            </el-table-column>
            <el-table-column label="月份" prop="flowMonth" show-overflow-tooltip></el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 50,100,1000]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
</div>

</template>

<script type="text/ecmascript-6">

import {getAccountList,getAgentList,getList_monthlyMeter,exportSync_monthlyMeter} from '@/api/staticsManagement/cardUseCycel.js'
import {messageBox,confirmBox} from '@/utils/common.js'

import resize from '@/mixins/resize.js'

export default {
    name:'monthlyMeter',
    mixins:[resize],
    data(){
        return {
            form:{
                accountId:'',
                agentId:'',
                iccidMark:'',
                startMonth:'',
                endMonth:''
            },
            accountList:[],
            agentList:[],
            tableData:[],
            pageSize:15,
            currentPage:1,
            total:0,

        }
    },
    mounted(){
        this._getAccountAgentList()
        this._getList_monthlyMeter()
    },
    methods:{
        searchTable(){
            this._getList_monthlyMeter()
        },
        exportExcel(){
            exportSync_monthlyMeter(this.form).then(res=>{
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText:'确定',
                    }).then(()=>{
                        this.$router.push('/tob/i_export_list')
                    });
                }else{
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    });
                }
            })
        },
        handleSizeChange(val){
            this.pageSize = val
            this._getList_monthlyMeter()
        },
        handleCurrentChange(val){
            this.currentPage = val
            this._getList_monthlyMeter()
        },
        _getAccountAgentList(){
            getAccountList().then((res)=>{
                this.accountList = res
            })
            getAgentList().then((res)=>{
                this.agentList = res
            })
        },
        _getList_monthlyMeter(){
            let params = {}
            params.pageSize = this.pageSize
            params.pageNo = this.currentPage
            params.type = this.type
            getList_monthlyMeter(Object.assign(params,this.form)).then((res) => {
                this.tableData = res.rows
                this.pageSize = res.pageSize
                this.currentPage = res.pageNo
                this.total = res.total
            })
        }
    }
}
</script>
